import Box from "@mui/material/Box";
import styled from "@emotion/styled";
import { styled as muiStyled } from "@mui/system";

export const RootContainer = muiStyled(Box)({
  height: "100%",
  fontFamily: "Poppins",
  overflow: "hidden",
});

export const HeaderContainer = muiStyled(Box)({
  fontSize: "18px",
  fontFamily: "Poppins",
  height: "40px",
  textAlign: "initial",
});

export const TypeContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  height: 90,
});

export const SettingsContainer = styled("div")({
  marginTop: "10px",
  marginBottom: "25px",
});

export const OptionsContainer = styled("div")({
  margin: "25px 0px",
});

export const StylesContainer = styled("div")({
  margin: "25px 0px",
});

export const BodyContainer = muiStyled(Box)({
  height: "calc(100% - 50px)",
  overflowY: "auto",

  "&::-webkit-scrollbar": {
    display: "none",
  },
});

export const CopyContainer = styled("div")({
  marginBottom: "40px",
});

export const TextContainer = styled("div")({
  margin: "10px 0px",
  fontFamily: "Poppins",
  fontSize: "14px",
});

export const ButtonTextContainer = styled("div")({
  margin: "20px 0px",
  fontFamily: "Poppins",
  fontSize: "16px",
});

export const LandingPageTypeContainer = styled("div")({
  marginTop: "1.5rem",
});

export const LandingPageTypeButtonsContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  marginTop: 15,
});

export const LandingPageHtmlButtonWrapper = styled("div")({
  marginRight: "2rem",
});

export const LandingPageSpacingContainer = styled("div")({
  marginTop: "1rem",
});

export const LandingPageSmallSpacingContainer = styled("div")({
  marginTop: ".5rem",
});

export const LandingPageExtraSpacingContainer = styled("div")({
  marginTop: "2.5rem",
});

export const QuestionHeaderContainer = styled("div")({
  display: 'flex',
  justifyContent: 'space-between',
})
